import { api } from '@goaltree/backend/convex/_generated/api'
import type { OptimisticLocalStore } from 'convex/browser'

import { logicalDayStr as localDay } from '@/lib/day'

/**
 * Optimistically add/remove today's completion for a habit in the getHabits
 * query, so the dot grid fills/clears instantly on complete/uncomplete.
 */
export function optimisticHabitCompletion(
  localStore: OptimisticLocalStore,
  taskId: string,
  completed: boolean,
) {
  const habits = localStore.getQuery(api.nodes.getHabits, {})
  if (!habits) return
  const today = localDay(Date.now())
  localStore.setQuery(
    api.nodes.getHabits,
    {},
    habits.map((h) => {
      if ((h._id as string) !== taskId) return h
      if (completed) {
        if (h.completions.some((ms) => localDay(ms) === today)) return h
        return { ...h, completions: [...h.completions, Date.now()] }
      }
      return { ...h, completions: h.completions.filter((ms) => localDay(ms) !== today) }
    }),
  )
}
